<template>
  <div>
    <headerNav title="大货小金库" />
    <div>
      <van-sticky>
        <div class="pmain">
          <div class="pprice">
            <span class="fl">当前余额:￥ {{ this.abp.userInfo.referralReward }}</span>
            <span class="fr"></span>
          </div>
          <!-- <div class="ffbtns">
            <van-button :color="$abctheme.basecolor" round @click="showwithdrawDialog(1)"
              >提现</van-button
            >
            <van-button :color="$abctheme.basecolor" round @click="showwithdrawDialog(2)"
              >转余额</van-button
            >
          </div> -->
          <van-checkbox-group
            v-model="selectreferralTypes"
            direction="horizontal"
            style="font-size: 12px; padding-left: 10px"
            @change="onRefresh"
          >
            <van-checkbox :name="0">董事星级返点</van-checkbox>
            <van-checkbox :name="3">推荐奖</van-checkbox>
             <van-checkbox :name="7">买断费</van-checkbox>
              <van-checkbox :name="8">提现</van-checkbox>
            <van-checkbox :name="1">官方业绩返点</van-checkbox>
            <van-checkbox :name="6">补货奖</van-checkbox>
            <van-checkbox :name="2">转货款</van-checkbox>
            <van-checkbox :name="10">差价</van-checkbox>
          </van-checkbox-group>
          <van-checkbox-group
            v-model="auditStatus"
            max="1"
            direction="horizontal"
            style="font-size: 12px; padding-left: 10px"
            @change="onRefresh"
          >
            <van-checkbox :name="1">待审核</van-checkbox>
            <van-checkbox :name="2">审核通过</van-checkbox>
             <van-checkbox :name="3">不通过</van-checkbox>
          </van-checkbox-group>
        </div>
      </van-sticky>

      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="navitem.loaded"
          :finished="navitem.loadingType == 'nomore' ? true : false"
          :finished-text="navitem.loadingType == 'nomore' ? '没有更多了' : '下拉加载更多'"
          @load="loadData"
        >
          <div v-for="(item, index) in navitem.list" class="mian-list" :key="index">
            <div class="mian-list-info">
              <div class="main-list-info-main">
                <div class="mian-list-info-data">
                  <span>审核状态：</span>
                  <span>{{ item.auditStatusName }}</span>
                </div>
                <div class="mian-list-info-data">
                  <span>关联单号：</span>
                  <span>{{ item.rechargeRecordTid }}</span>
                </div>
                <div class="mian-list-info-data">
                  <span>奖励金额：</span>
                  <span>{{ item.money }}</span>
                </div>

                <div class="mian-list-info-data">
                  <span>奖励类型：</span>
                  <span>{{ item.referralTypeName }}</span>
                </div>
                 <div class="mian-list-info-data" v-if="item.referralType==0 && item.score">
                  <span>评分：</span>
                  <span>{{ item.score }}</span>
                </div>
                  <div class="mian-list-info-data" v-if="item.referralType==0 && item.score">
                  <span>原奖励金额：</span>
                  <span>{{ item.oldMoney }}</span>
                </div>
                <div class="mian-list-info-data-last">时间：{{ item.creationTime }}</div>
              </div>
            </div>
            <div class="mian-list-mark" v-if="item.comment">
              <div>备注：{{ item.comment }}</div>
                    <div v-if="item.rejectReason">拒绝通过原因： {{item.rejectReason}}</div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <van-dialog
      v-model="showwithdraw"
      :title="showwithdrawTitle"
      show-cancel-button
      @confirm="withdraw"
    >
      <van-field v-model="money" label="金额" input-align="right" />
      <van-radio-group v-model="method" v-if="withdrawtype == 2">
        <van-cell-group>
          <van-cell title="转大货货款" clickable @click="method = '0'">
            <template #right-icon>
              <van-radio name="0" />
            </template>
          </van-cell>
          <van-cell title="转物料货款" clickable @click="method = '1'">
            <template #right-icon>
              <van-radio name="1" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      date: "",
      navitem: {
        state: 0,
        text: "全部",
        loadingType: "more",
        loaded: false,
        getparams: {
          sorting: "",
          maxResultCount: 10,
          skipCount: 0,
          referralTypes: [],
          auditStatus:undefined
        },
        list: [],
      },
      loading: false,
      finished: false,
      refreshing: false,
      referraltypeenumArr: [],
auditStatus:[2],
      showwithdraw: false,
      showwithdrawTitle: "提现金额",
      withdrawtype: 0,
      money: "",
      method: "0",
      level1status: [],
      level2status: [],
      level3status: [],
      selectreferralTypes: [],
    };
  },
  created() {
    this.ajax
      .get("/api/services/app/Common/GetEnumKeyValue?name=referraltypeenum")
      .then((x) => {
        x.result.map((m) => {
          if ([0, 1, 2].indexOf(m.id) != -1) {
            this.level1status.push(m);
          }
          if ([4, 5].indexOf(m.id) != -1) {
            this.level2status.push(m);
          }
          if ([9, 11].indexOf(m.id) != -1) {
            this.level3status.push(m);
          }
        });
      });
  },
  methods: {
    onRefresh() {
      this.loadData("refresh");
    },
    loadData(source) {
      let navItem = this.navitem;
      // let state = navItem.state;

      if (source === "tabChange" && navItem.loaded === true) {
        //tab切换只有第一次需要加载数据
        return;
      }
      if (navItem.loadingType === "loading" || navItem.loadingType === "nomore") {
        //防止重复加载
        if (source != "refresh") {
          return;
        }
      }
      if (source === "refresh") {
        this.navitem.list = [];
        this.navitem.getparams.skipCount = 0;
      }
      this.navitem.getparams.auditStatus=this.auditStatus[0];
      navItem.loadingType = "loading";
      var params = navItem.getparams;
      console.log(this.selectreferralTypes);
      this.navitem.getparams.referralTypes = [];
      if (this.selectreferralTypes.indexOf(0) != -1) {
        this.level1status.forEach((p) => {
          this.navitem.getparams.referralTypes.push(p.id);
        });
      }
      if (this.selectreferralTypes.indexOf(1) != -1) {
        this.level2status.forEach((p) => {
          this.navitem.getparams.referralTypes.push(p.id);
        });
      }
      if (this.selectreferralTypes.indexOf(2) != -1) {
        this.level3status.forEach((p) => {
          this.navitem.getparams.referralTypes.push(p.id);
        });
      }
      this.selectreferralTypes.forEach((f) => {
        if ([0, 1, 2].indexOf(f) == -1) {
          this.navitem.getparams.referralTypes.push(f);
        }
      });
      //加载数据
      this.ajax
        .post("/api/services/app/PhoneWallet/QueryMyReferralRewardRecordPages", params)
        .then((x) => {
          this.navitem.getparams.skipCount += this.navitem.getparams.maxResultCount;
          let totalcount = x.result.totalCount;
          this.navitem.list = this.navitem.list.concat(x.result.items);
          //console.log(this.navList);
          // item = Object.assign(item, this.orderStateExp(item.state));
          this.navitem.loadingType =
            totalcount > this.navitem.getparams.skipCount ? "more" : "nomore";
        })
        .finally(() => {
          this.$set(this.navitem, "loaded", false);
          this.refreshing = false;
        });
    },
    showwithdrawDialog(e) {
      this.showwithdrawTitle = "";
      this.withdrawtype = e;
      if (e == 1 || e == 3) {
        this.showwithdrawTitle = "提现申请";
      }
      if (e == 2 || e == 4) {
        this.showwithdrawTitle = "转货款申请";
      }
      this.showwithdraw = true;
    },
    withdraw() {
      if (!this.money) {
        this.$dialog.alert({ message: "请输入正确的金额" });
        return;
      }
      if (this.withdrawtype == 1) {
        this.ajax
          .post(
            "/api/services/app/PhoneWallet/ApplyReferralRewardWithdraw?money=" +
              this.money
          )
          .then((x) => {
            this.$toast.success("申请成功");
          });
      }
      if (this.withdrawtype == 2) {
        this.ajax
          .post(
            "/api/services/app/PhoneWallet/ReferralRewardToLargeLoans?money=" +
              this.money +
              "&method=" +
              this.method
          )
          .then((x) => {
            this.$toast.success("申请成功");
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.fl {
  font-size: 25px;
  line-height: 60px;
}

.fr {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translate(0, -50%);
  font-size: 26px;
  font-weight: bold;
}

.ffbtns {
  text-align: right;
  padding: 0px 10px;
}

.ffbtns button {
  margin-right: 10px;
  padding: 5px 15px;
  border-radius: 4px;
  height: auto;
}

.pmain {
  background-color: white;
}

.pprice {
  position: relative;
  padding: 0px 10px;
}

.mian-list {
  background-color: #fff;
  font-size: 12px;
  border-radius: 8px;
  margin: 10px;
  padding: 10px;
  box-shadow: 1px 1px 4px #c3c3c3;
  line-height: 18px;
}

.mian-list-info {
  padding: 5px 0 5px 5px;
  font-size: 14px;
  position: relative;
  min-height: 100px;
  word-break: break-all;
}

.mian-list-pic {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100px;
  height: 100px;
  transform: translate(0, -50%);
}

.mian-list-pic img {
  width: 100%;
  height: 100%;
}
.mian-list-info-data{
  line-height: 20px;
  letter-spacing:1px;
  font-size: 13px;
}
.mian-list-info-data:first {
  min-height: 30px;
  padding-right: 90px;
}

.mian-list-info-data-last {
  text-align: right;
}

.main-list-info-main {
  position: relative;
}

.min-height {
  min-height: 18px;
  margin-bottom: 5px;
}

.mian-list-info-left-tag {
  position: absolute;
  left: 0;
}

.mian-list-info-right {
  text-align: right;
}

.mian-list-info-right-tag {
  position: absolute;
  right: 0;
}

.mian-list-mark {
  border-top: 1px solid #e2e2e2;
  padding-top: 10px;
  font-size: 15px;
}
</style>
